import React from "react";
import MemberModal from "./components/MemberModal";

const Wiki = ({ fontSize }) => {
  return (
    <div>
      <div className="wikiDiv membersDiv">
        <div className="cardContainer grid-container">
          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Wiki"
            name="Boya Zhang "
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/boya-zhang-profile.jpg"
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/boya-zhang-profile.jpg "
            }
            program="Computer Science "
            term="3A "
            bird="Early Bird "
            lab="Test tube "
            travel="Japan "
          />
          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Wiki"
            name="Elizabeth Sun "
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/elizabeth-sun-profile.jpeg"
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/silly-photos/elizabeth-sun-silly.jpeg "
            }
            program="Global Business and Digital Arts "
            term="3A "
            bird="Perpetually Tired "
            lab="Bunsen burner "
            travel="London, England "
          />
          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Wiki"
            name="Yosha Aneja "
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/yosha-aneja-profile.jpg"
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/yosha-aneja-profile.jpg "
            }
            program="Systems Design Engineering "
            term="1B "
            bird="Night Owl "
            lab="Lab coat "
            travel="Spain "
          />
          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Wiki"
            name="Youngwoo Lee "
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/youngwoo-lee-profile.jpg"
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/youngwoo-lee-profile.jpg "
            }
            program="Chemical Engineering "
            term="3A "
            bird="Perpetually Tired "
            lab="Goggles "
            travel="Japan "
          />
        </div>
      </div>
    </div>
  );
};

export default Wiki;
